
import TableList from "@components/templates/tablelist";
import { HttpGetPrimaryList, HttpCheckPrimary, HttpSubmitPrimary, HttpDeletePrimaryOne, HttpCancelPrimaryOne, HttpCopyPrimaryOne } from "@/service/proddevelop";
import { HttpGetCategories } from '@/service/products/allproducts';
import compSubmitprice from './alert/submitprice';
import compMaxImage from './alert/maximage';

import { mapState,mapGetters } from "vuex";
import comIndex from './update';
import comSubmitprice from './alert/submitprice';
import compseleMutiupload from './alert/selectmutiupload';

import mixin from '../mixins';
export default {
    mixins: [TableList,mixin],
    components: {
        comIndex,
        comSubmitprice,
        compSubmitprice,
        compMaxImage,
        compseleMutiupload,
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            Adaptive: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: {show: true},
            erpSkusList:[],
            category:'',
            categoryList:[],
            isSuper: this.$store.state.userinfo.isSuper,
        }
    },
    created(){
        this.getcategory()
    },
    methods: {
        ajaxRequest: HttpGetPrimaryList,
        interceptRequest(params) {
            
            params.delayStatus = params.search.delayStatus
            delete params.search.delayStatus

            if(params.search.EQ_status  === 11){
                params.isDelay = 1
                delete params.search.EQ_status
            }
            // return search

            return params
        },
        toolsRender(){ //自定义工具行
            return <div class="back-fff padding-10 margin-bottom-10">
                <vButton class="margin-right-5" theme="primary" nativeOnClick={this.handleOperates.bind(this,'','add')}>新增</vButton>
                <Dropdown class="margin-right-5">
                    <Button type="success">
                        查询条件导出
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,this.formData,'expprice')}>导出报价单</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,this.formData,'expproduct')}>导出预选产品</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,this.formData,'expdemo')}>导出打样需求</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <vButton v-show={this.isSuper} class="margin-right-5" theme="warning" nativeOnClick={this.handleOperates.bind(this,'','importerpsku')}>反向关联ERPSKU</vButton>
                <Dropdown class="margin-right-5">
                    <Button >
                        更多操作
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,'','allsubmit',true)}>批量提交</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,'','allaudit',true)}>批量审核</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,'','allcancel',true)}>批量取消</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,'','allrejected',true)}>批量驳回</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown class="margin-right-5 pull-right">
                    <Button type="info">
                        批量导入
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,'','impnewproduct')}>导入新品预选</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,'','impfactory')}>导入工厂报价</DropdownItem>
                        <DropdownItem nativeOnClick={this.handleOperates.bind(this,'','impnews')}>导入打样报告</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'primaryUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    var url=this.$router.resolve({
                        name: "primaryUpdate",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title:'查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "primaryUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'impnewproduct':
                    // 点击导入按钮
                    this.operate = {
                        show: true,
                        title: '批量导入',
                        width:460,
                        showFooter: false,
                        data: {},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentPreselection/import",
                        name: "excelFile",
                        component: "compUpload",
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productDevelopmentPreselection/excel', {}, 'download')
                        }
                    }
                    break;
                case 'impfactory':
                    // 点击导入按钮
                    this.operate = {
                        show: true,
                        title: '批量导入',
                        width:460,
                        showFooter: false,
                        data: {isSave:1},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentOffer/import",
                        name: "excelFile",
                        component: "compUpload",
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productDevelopmentOffer/excel', {}, 'download')
                        }
                    }
                    break;
                case 'impnews':
                    this.operate = {
                        show: true,
                        title: '批量导入打样报告',
                        width:460,
                        showFooter: false,
                        actionurl: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
                        name: "multipartFile",
                        component: "compseleMutiupload",
                        warningtitle:'<div class="text-left">注意：</br>1、打印报告请以预选号@供应商名称@自定义后缀命名，比如PD2021020100027@佳和工厂@打样报告0203 </br>2、选择更新，则同一个预选号如果再次导入新文件，会将该预选已存在的打样报告覆盖；</br>3、选择新增，则不会覆盖该预选已存在的打样报告，为新插入一条。</div>',
                        formdata:[
                            {
                                span: 24,
                                label: '请选择方式',
                                key: 'isUpdate',
                                tag: 'vRadio',
                                props: {
                                    strict: false,
                                },
                                options: [{
                                    trueValue: 1,
                                    label: '更新'
                                }, {
                                    trueValue: 0,
                                    label: '新增'
                                }]
                            },
                        ],
                    }
                break;

                case 'importerpsku':
                    this.operate = {
                        show: true,
                        title: '批量导入',
                        width:460,
                        showFooter: false,
                        // data: {isSave:1},
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentRelated/import",
                        name: "excelFile",
                        component: "compUpload",
                        // download:()=>{
                        //     this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productDevelopmentOffer/excel', {}, 'download')
                        // }
                    }
                break;
                case 'expprice':
                    let queryObj1 = {}
                    Object.keys(this.formData.search).map(item => {
                        queryObj1[`search[${item}]`] = this.formData.search[item]    
                    })
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentPreselection/exportByFilter", {type:1,...queryObj1}, 'download').catch(err => {
                    })
                    break;
                case 'expproduct':
                    let queryObj2 = {}
                    Object.keys(this.formData.search).map(item => {
                        queryObj2[`search[${item}]`] = this.formData.search[item]    
                    })
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentPreselection/exportByFilter", {type:0,...queryObj2}, {
                        executor: 'request',
                        download: true,
                    }).catch(err => {
                    })
                    break;
                case 'expdemo':
                    let queryObj3 = {}
                    Object.keys(this.formData.search).map(item => {
                        queryObj3[`search[${item}]`] = this.formData.search[item]    
                    })
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentPreselection/exportByFilter", {type:2,...queryObj3}, 'download').catch(err => {
                    })
                    break;

                case "allsubmit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "提交审核",
                        width: 460,
                        params:{ids:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required:false
                            }
                        ],
                        ajaxRequest:HttpSubmitPrimary
                    };
                    break;
                case "allaudit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "审核",
                        width: 460,
                        params:{statusId:2,ids:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                
                            }
                        ],
                        ajaxRequest:HttpCheckPrimary
                    };
                    break;
                case "allcancel":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "批量取消",
                        width: 460,
                        params:{ids:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "取消原因"
                            }
                        ],
                        ajaxRequest:HttpCancelPrimaryOne
                    };
                    break;
                case "alldelete":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "批量删除",
                        width: 460,
                        params:{id:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注"
                            }
                        ],
                        ajaxRequest:HttpDeletePrimaryOne
                    };
                    break;
                case "allrejected":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "批量驳回",
                        width: 460,
                        params:{statusId:8,ids:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注"
                            }
                        ],
                        ajaxRequest:HttpCheckPrimary
                    };
                    break;
                case "allcopy":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "复制单据",
                        width: 460,
                        params:{id:params},
                        ajaxRequest:HttpCopyPrimaryOne
                    };
                    break;
                case "allqueryprice":
                    let subdata = {
                        orderid:params.id,
                        precoding:params.precoding,
                        orderstatus:params.status,
                        submitterName:params.submitterName,
                        submitTime:params.submitTime,
                        bidderName:params.bidderName,
                        offerTime:params.offerTime,
                        reviewerName:params.reviewerName,
                        approvedTime:params.approvedTime,
                        docListdata:params.attachMeta ? JSON.parse(params.attachMeta).items : []
                    }
                    this.operate = {
                        title:'查看报价',
                        show:true,
                        width:1200,
                        component: "compSubmitprice",
                        entrydata:subdata,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "maximage":
                    this.operate = {
                        show: true,
                        title:'查看图片',
                        width: 460,
                        component: "compMaxImage",
                        imagurl:params,
                        showFooter:false
                    };
                    break;
                    
                
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id,status } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show:status==0,
                to: {
                    name: 'primaryUpdate',
                    params: { type: 'edit' },
                    query: { id },
                },
            },{
                label:'提交审核',
                show:status==0,
                params:id,
                operate:'allsubmit'
            },{
                label:'删除',
                show:status==0,
                params:id,
                operate:'alldelete'
            },{
                label:'查看报价',
                show:status==5 || status==6,
                params:row,
                operate:'allqueryprice'
            },{
                label:'复制单据',
                show:true,
                params:id,
                operate:'allcopy'
            },{
                label:'取消',
                show:status!=0 || status!=7,
                params:id,
                operate:'allcancel'
            }]
        },
        getcategory(){
            HttpGetCategories().then(res=>{
                this.categoryList = res.data.filter(item=>{
                    return item.level == 3
                })
            })
        },
        // 计算天数
        getDayNumber(date1,date2){
            let now = new Date(date1); 
            let sdate = new Date(date2); 
            let days = now.getTime() - sdate.getTime(); 
            let day = parseInt(days / (1000 * 60 * 60 * 24)); 
            return day; 
        }
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getAllProductPerson']),
        ...mapState('boss', ['accountTypes']),
        getUserList(){
            return this.getAllProductPerson.filter(function(item){
                // console.log(item)
                return item.label != ''
            })
        },
        TabsData(){
            return [
                {
                    name: "全部",
                    key:'EQ_status',
                    val: null
                }, {
                    name: "草稿",
                    key:'EQ_status',
                    val: 0
                }, {
                    name: "待审核",
                    key:'EQ_status',
                    val: 1
                }, {
                    name: "待询价",
                    key:'EQ_status',
                    val: 2
                }, {
                    name: "待选择打样工厂",
                    key:'EQ_status',
                    val: 3
                }, {
                    name: "待打样",
                    key:'EQ_status',
                    val: 4
                }, {
                    name: "待确认报价",
                    key:'EQ_status',
                    val: 5
                }, {
                    name: "待正式建档",
                    key:'EQ_status',
                    val: 6
                }, {
                    name: "已建档",
                    key:'EQ_status',
                    val: 7
                }, {
                    name: "预选产品驳回",
                    key:'EQ_status',
                    val: 8
                }, {
                    name: "报价驳回",
                    key:'EQ_status',
                    val: 9
                }, {
                    name: "已取消",
                    key:'EQ_status',
                    val: 10
                }, 
                {
                    name: "超时单",
                    key:'EQ_status',
                    val: 11
                }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            let widthStyle = 'width: 200px'
            return  [
                {
                    label: "预编码",
                    tag: 'vInput',
                    key: 'CN_precoding',
                    show:true,
                },
                {
                    label: "产品标题",
                    tag: 'vInput',
                    key: 'CN_title',
                    show:true,
                },
                {
                    label: "品类",
                    tag: 'Select',
                    key: 'EQ_categoryId',
                    options: this.categoryList.map(item=>{
                        return {
                            value:item.id,
                            label:item.code+'-'+item.name
                        }
                    }),
                    props:{
                        filterable:true,
                        // multiple: true
                    },
                    style: widthStyle
                },
                
                {
                    label: "目标站点",
                    tag: 'Select',
                    key: 'IN_targetSite',
                    options: this.accountTypes.map(item=>{
                        return {
							value: item.name,
							label: item.name
						}
                    }),
					props: {
						filterable: true,
                    },
                    style: widthStyle
                },
                {
                    label: "单据状态",
                    tag: 'Select',
                    key: 'IN_status',
                    options: this.getPrimaryStatus,
                    props:{
                        filterable:true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: "项目",
                    tag: 'Select',
                    key: 'IN_lineId',
                    options: this.getNewProductList,
                    props:{
                        filterable:true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: "来源",
                    key: 'CN_source',
                    tag: "Select",
                    options:this.getSource,
                    style: widthStyle,
                },
                {
                    label: "提交人",
                    tag: 'Select',
                    key: 'EQ_submitterName',
                    options:this.getUserList,
                    props:{
                        filterable:true,
                        clearable:true,
                    },
                    style: widthStyle
                },
                
                {
                    label: '审核人',
                    tag: 'Select',
                    key: 'EQ_reviewerName',
                    options:this.getUserList,
                    props:{
                        filterable:true,
                        clearable:true,
                    },
                    style: widthStyle
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props:{
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: "超时类型",
                    key: 'delayStatus',
                    tag: "Select",
                    options:this.delayList,
                    style: widthStyle,
                    props:{
                        filterable:true,
                        multiple: true
                    },
                },
                {
                    label: "部门",
                    tag: 'vInput',
                    key: 'CN_department',
                    style: widthStyle
                },
                {
                    label: "备注",
                    tag: 'vInput',
                    key: 'CN_remark',
                    style: widthStyle
                },
                {
                    label: "推荐产品编号",
                    tag: 'vInput',
                    key: 'EQ_recommendId',
                    style: widthStyle
                },
                {
                    label: "ERP SKU",
                    tag: "vInput",
                    key: "EQ_erpSkuList",
                    style: widthStyle
                },
                
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: '操作',
                width: 90,
                render:this.getOperateNodes
            }, 
            {
                title: '预编码',
                // width: 90,
                key:'precoding',
                render:(h,{row})=>{
                    return (
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.precoding}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>
                    )
                }
            }, 
            {
                title: '品类/标题',
                key:'name',
                // sortable: true,
                render:(h,{row})=>{
                    return (
                    <div>
                        <div class="text-center"><a onClick={this.handleOperates.bind(this, row.pictureUrl, 'maximage')}><img src={row.pictureUrl} style="max-width:100%;height:60px" /></a></div>
                        <div>品类：{row.categoryCodeName || '--'}</div>
                        <div>产品标题：{row.title}</div>
                    </div>
                    )
                }
            },
            {
                title: '最晚报价日期',
                key:'latestOffer',
                width:this.formData.search.EQ_status == 2 ? '140': 0,
                sortable: true,
                render:(h,{row})=>{
                    let showSpan1 = 0;
                    if(row.offerTime){
                        this.getDayNumber(row.offerTime ? row.offerTime.split(' ')[0].replace('/-/g','/') : '',row.latestOffer ? row.latestOffer.split(' ')[0].replace('/-/g','/') : '') > 0 ? showSpan1 = 1 : showSpan1 = 2
                        // console.log(showSpan1,'1111')
                    }else{
                        this.getDayNumber(this.getDay(0).replace('/-/g','/'),row.latestOffer ? row.latestOffer.split(' ')[0].replace('/-/g','/') : '') > 0 ? showSpan1 = 1 : showSpan1 = 2
                        // console.log(showSpan1,'222')
                    }
                    
                
                    return <div>
                        {(row.latestOffer||'').split(' ')[0]}
                        <span v-show={showSpan1 === 1} class="order-urgent-span margin-left-10" style="cursor: pointer;">超时</span>
                    </div>
                }
            },
            {
                title: '最晚确认报价日期',
                key:'latestConfirmOffer',
                width:this.formData.search.EQ_status == 3 ||this.formData.search.EQ_status == 4||this.formData.search.EQ_status == 5 ? '140': 0,
                sortable: true,
                render:(h,{row})=>{
                    let showSpan2 = false;
                    if(row.checkOfferTime){
                        // console.log(this.getDayNumber(row.checkOfferTime ? row.checkOfferTime.split(' ')[0].replace('/-/g','/') : '',row.offerTime ? row.offerTime.replace('/-/g','/') : ''),'333')
                        this.getDayNumber(row.checkOfferTime ? row.checkOfferTime.split(' ')[0].replace('/-/g','/') : '',row.latestConfirmOffer ? row.latestConfirmOffer.replace('/-/g','/') : '') > 0 ? showSpan2 = true : showSpan2 = false
                    }else{
                        // console.log(this.getDayNumber(this.getDay(0).replace('/-/g','/'),row.checkOfferTime ? row.checkOfferTime.split(' ')[0].replace('/-/g','/') : ''),'444')
                        this.getDayNumber(this.getDay(0).replace('/-/g','/'),row.checkOfferTime ? row.checkOfferTime.split(' ')[0].replace('/-/g','/') : '') > 0 ? showSpan2 = true : showSpan2 = false
                    }
                    return <div>
                        {(row.latestConfirmOffer||'').split(' ')[0]}
                        <span v-show={showSpan2 } class="order-urgent-span margin-left-10" style="cursor: pointer;">超时</span>
                        </div>
                }
            },
            
            {
                title: '其他信息',
                render:(h, { row })=>{
                    return (
                        <div>
                            <div>部门/提交人：{row.department || '--'} {row.submitterName}</div>
                            <div>来源：{row.source}</div>
                            <div>期望FOB：{row.expectFob}</div>
                            {/* <div>最低报价：{row.estimatedSalesVolume}</div> */}
                            <div>目标售价：{row.targetPrice}</div>
                            <div>关联正式产品：{row.erpSkuList}</div>
                            <div>备注：{row.remark}</div>
                        </div>
                    )
                }
            },
            {
                title: '单据状态',
                width:120,
                render: (h, { row }) => this.findRenderLabel(this.getPrimaryStatus, row.status,'label',true),
            },
            {
                title: '提交/审核/报价/建档日期',
                render:(h, { row })=>{
                    return (
                        <div>
                            {(row.submitTime || '--').split(' ')[0]} <br/>
                            {(row.approvedTime || '--').split(' ')[0]} <br/>
                            {(row.offerTime || '--').split(' ')[0]} <br/>
                            {(row.filingTime || '--').split(' ')[0]}
                        </div>
                    )
                }
            },
            {
                title: '更新时间',
                key: 'updatedAt',
                width:140,
                sortable: true
            },
        ];
        },
        
    },

};
